// Vietnamese translations for physical exam parameter options
// This file provides Vietnamese translations for all the radio button and select options
// used in physical exam forms while maintaining English values for data storage

export const PHYSICAL_EXAM_OPTIONS_VI = {
  // Common options used across multiple parameters
  'Normal': 'Bình thường',
  'Abnormal': 'Bất thường',
  'Present': 'Có',
  'Absent': 'Không có',
  'Unable to assess': 'Không thể đánh giá',
  'Not assessed': 'Chưa đánh giá',
  'Not Assessed': 'Chưa đánh giá',
  'Indeterminate': 'Không xác định',
  'No': 'Không',
  'Yes': 'Có',
  'False': 'Không',
  'True': 'Có',
  'None': 'Không có',
  'Mild': 'Nhẹ',
  'Moderate': 'Vừa',
  'Severe': 'Nặng',
  'Small': 'Nhỏ',
  'Large': 'Lớn',
  'Left': 'Trái',
  'Right': 'Phải',
  'Bilateral': 'Hai bên',
  'Midline': 'Đường giữa',

  // Specific physical exam findings
  'Present Left': 'Có bên trái',
  'Present Right': 'Có bên phải',
  'Present Bilateral': 'Có hai bên',
  'Present Bilateral/Midline': 'Có hai bên/đường giữa',
  'Present Midline': 'Có ở đường giữa',

  // Integumentary system specific
  'Jaundiced': 'Vàng da',
  'Pale': 'Nhợt nhạt',
  'Cyanotic': 'Tím tái',
  'Flushed': 'Đỏ bừng',
  'Mottled': 'Đốm',
  'Dry': 'Khô',
  'Moist': 'Ẩm',
  'Oily': 'Nhờn',
  'Rough': 'Thô ráp',
  'Smooth': 'Mịn',
  'Warm': 'Ấm',
  'Cool': 'Mát',
  'Hot': 'Nóng',
  'Cold': 'Lạnh',

  // HEENT (Head, Eyes, Ears, Nose, Throat) specific
  'Reactive': 'Phản ứng',
  'Non-reactive': 'Không phản ứng',
  'Equal': 'Đều',
  'Unequal': 'Không đều',
  'Round': 'Tròn',
  'Irregular': 'Không đều',
  'Dilated': 'Giãn',
  'Constricted': 'Co',
  'Clear': 'Trong',
  'Cloudy': 'Đục',
  'Red': 'Đỏ',
  'Yellow': 'Vàng',
  'Green': 'Xanh lá',
  'Brown': 'Nâu',
  'Black': 'Đen',
  'White': 'Trắng',
  'Pink': 'Hồng',
  'Blue': 'Xanh dương',

  // HEENT Eyes specific
  'Pale': 'Nhợt nhạt',
  'Injected': 'Sung huyết',
  'Anicteric': 'Không vàng da',
  'Icteric': 'Vàng da',
  'Intact': 'Nguyên vẹn',
  'Deficit': 'Thiếu hụt',
  'Sluggish': 'Chậm',
  'Dysmetria': 'Rối loạn đo lường',

  // HEENT Ears specific
  'Inflamed': 'Viêm',
  'Obstructed': 'Tắc nghẽn',
  'AC > BC': 'Dẫn truyền khí > dẫn truyền xương',
  'BC > AC': 'Dẫn truyền xương > dẫn truyền khí',
  'Midline': 'Đường giữa',
  'Lateralizes Left': 'Lệch trái',
  'Lateralizes Right': 'Lệch phải',

  // HEENT Mouth/Throat specific
  'Moist/Pink': 'Ẩm/Hồng',
  'Dry': 'Khô',
  'Deviated': 'Lệch',
  'Class I': 'Loại I',
  'Class II': 'Loại II',
  'Class III': 'Loại III',
  'Class IV': 'Loại IV',
  '0': '0',
  '1+': '1+',
  '2+': '2+',
  '3+': '3+',
  '4+': '4+',

  // Thyroid specific
  'Enlarged': 'To',
  'Nodule Palpable': 'Sờ thấy nốt',

  // Lymph Nodes specific
  'Not Palpable': 'Không sờ thấy',
  'Palpable Left': 'Sờ thấy bên trái',
  'Palpable Right': 'Sờ thấy bên phải',
  'Palpable Bilateral': 'Sờ thấy hai bên',

  // Chest/Respiratory specific
  'Symmetric': 'Đối xứng',
  'Asymmetric': 'Không đối xứng',
  'Decreased': 'Giảm',
  'Present Left': 'Có bên trái',
  'Present Right': 'Có bên phải',
  'Present Bilateral': 'Có hai bên',

  // Cardiovascular specific
  'Regular': 'Đều',
  'Irregular': 'Không đều',
  'Regularly Irregular': 'Không đều có quy luật',
  'Irregularly Irregular': 'Không đều không quy luật',
  'Tachycardic': 'Nhanh',
  'Bradycardic': 'Chậm',
  'S1 S2': 'S1 S2',
  'Murmur': 'Tiếng thổi',
  'Gallop': 'Tiếng phi nước đại',
  'Rub': 'Tiếng cọ xát',
  'Click': 'Tiếng lách cách',
  'Absent Bilateral': 'Không có hai bên',
  'Normal Bilateral (<2s)': 'Bình thường hai bên (<2s)',
  'Abnormal Left (>2s)': 'Bất thường bên trái (>2s)',
  'Abnormal Right (>2s)': 'Bất thường bên phải (>2s)',
  'Abnormal Bilateral (>2s)': 'Bất thường hai bên (>2s)',
  'Displaced': 'Dịch chuyển',
  'Normal Bilateral (2+)': 'Bình thường hai bên (2+)',

  // Respiratory specific
  'Clear to auscultation': 'Trong khi nghe',
  'Diminished': 'Giảm',
  'Absent': 'Không có',
  'Crackles': 'Ran ẩm',
  'Wheezes': 'Ran khô',
  'Rhonchi': 'Ran thô',
  'Stridor': 'Ran rít',
  'Pleural friction rub': 'Tiếng cọ xát màng phổi',
  'Labored': 'Khó khăn',
  'Unlabored': 'Không khó khăn',
  'Shallow': 'Nông',
  'Deep': 'Sâu',
  'Rapid': 'Nhanh',
  'Slow': 'Chậm',

  // Abdominal specific
  'Soft': 'Mềm',
  'Firm': 'Cứng',
  'Rigid': 'Cứng như gỗ',
  'Distended': 'Chướng',
  'Flat': 'Phẳng',
  'Scaphoid': 'Lõm',
  'Hyperactive': 'Tăng',
  'Hypoactive': 'Giảm',
  'Normoactive': 'Bình thường',
  'Tender': 'Đau',
  'Non-tender': 'Không đau',
  'Rebound tenderness': 'Đau phản hồi',
  'Guarding': 'Co cứng phòng vệ',
  'Mass': 'Khối',
  'Organomegaly': 'To tạng',
  'Hepatomegaly': 'To gan',
  'Splenomegaly': 'To lách',

  // Bowel sounds specific
  'Normoactive': 'Bình thường',
  'Hypoactive': 'Giảm',
  'Hyperactive': 'Tăng',

  // Musculoskeletal specific
  'Full range of motion': 'Phạm vi chuyển động đầy đủ',
  'Limited range of motion': 'Phạm vi chuyển động hạn chế',
  'Painful range of motion': 'Chuyển động đau',
  'Stiff': 'Cứng',
  'Flexible': 'Linh hoạt',
  'Weak': 'Yếu',
  'Strong': 'Mạnh',
  'Atrophic': 'Teo',
  'Hypertrophic': 'Phì đại',
  'Swollen': 'Sưng',
  'Deformed': 'Biến dạng',
  'Stable': 'Ổn định',
  'Unstable': 'Không ổn định',

  // Neurological specific
  'Brisk': 'Nhanh',
  'Diminished': 'Giảm',
  'Absent': 'Không có',
  'Hyperreflexic': 'Tăng phản xạ',
  'Hyporeflexic': 'Giảm phản xạ',
  'Alert': 'Tỉnh táo',
  'Oriented': 'Định hướng',
  'Confused': 'Lú lẫn',
  'Lethargic': 'Uể oải',
  'Stuporous': 'Hôn mê nông',
  'Comatose': 'Hôn mê',
  'Cooperative': 'Hợp tác',
  'Uncooperative': 'Không hợp tác',
  'Agitated': 'Kích động',
  'Calm': 'Bình tĩnh',

  // Lymphatic specific
  'Palpable': 'Sờ thấy',
  'Non-palpable': 'Không sờ thấy',
  'Mobile': 'Di động',
  'Fixed': 'Cố định',
  'Tender': 'Đau',
  'Non-tender': 'Không đau',
  'Enlarged': 'To',
  'Normal size': 'Kích thước bình thường',

  // Skin specific findings
  'Intact': 'Nguyên vẹn',
  'Broken': 'Tổn thương',
  'Ulcerated': 'Loét',
  'Scarred': 'Có sẹo',
  'Tattooed': 'Có hình xăm',
  'Pigmented': 'Có sắc tố',
  'Depigmented': 'Mất sắc tố',
  'Rash': 'Phát ban',
  'Lesion': 'Tổn thương',
  'Nodule': 'Nốt',
  'Papule': 'Sẩn',
  'Vesicle': 'Bóng nước',
  'Pustule': 'Mụn mủ',
  'Macule': 'Đốm',
  'Patch': 'Mảng',

  // Examination quality indicators
  'Adequate': 'Đầy đủ',
  'Inadequate': 'Không đầy đủ',
  'Limited': 'Hạn chế',
  'Complete': 'Hoàn chỉnh',
  'Incomplete': 'Không hoàn chỉnh',
  'Satisfactory': 'Thỏa mãn',
  'Unsatisfactory': 'Không thỏa mãn',

  // Additional Musculoskeletal specific
  'Negative Bilateral': 'Âm tính hai bên',
  'Positive Left': 'Dương tính bên trái',
  'Positive Right': 'Dương tính bên phải',
  'Positive Bilateral': 'Dương tính hai bên',
  'Present Bilateral/Midline': 'Có hai bên/giữa',

  // Additional Neurological specific
  'Intact Bilateral': 'Nguyên vẹn hai bên',
  'Affected Left': 'Bị ảnh hưởng bên trái',
  'Affected Right': 'Bị ảnh hưởng bên phải',
  'Affected Bilateral': 'Bị ảnh hưởng hai bên',
  'Impaired': 'Suy giảm',
  'Negative': 'Âm tính',
  'Positive': 'Dương tính',

  // Additional Musculoskeletal range of motion specific
  'Limited Left': 'Hạn chế bên trái',
  'Limited Right': 'Hạn chế bên phải',
  'Limited Bilateral': 'Hạn chế hai bên',
  'Normal Bilateral': 'Bình thường hai bên'
};

/**
 * Get Vietnamese translation for a physical exam parameter option
 * @param {string} option - The English option value
 * @returns {string} - Vietnamese translation or original if not found
 */
export const getPhysicalExamOptionTranslation = (option) => {
  return PHYSICAL_EXAM_OPTIONS_VI[option] || option;
};

/**
 * Translate an array of options to Vietnamese
 * @param {Array} options - Array of English option values
 * @returns {Array} - Array of Vietnamese translations
 */
export const translatePhysicalExamOptions = (options) => {
  if (!Array.isArray(options)) return options;
  return options.map(option => getPhysicalExamOptionTranslation(option));
};

export default {
  PHYSICAL_EXAM_OPTIONS_VI,
  getPhysicalExamOptionTranslation,
  translatePhysicalExamOptions
};
